//
// OpenStreetMapProvider.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";
import "./MapLayerProvider";
import "../../../maps/OpenStreetMapProviderType";
import "./TileServer";

var OpenStreetMapProvider = createModule("commons::OpenStreetMapProvider", ["commons::PropertyOwner","commons::BaseModel","commons::AbstractMapProvider","commons::MapLayerProvider"], EventDispatcher, [
    ,
    {
        maxResolution: 6,
        tileServers: [1],
        context: 7,
        numResolutions: 4,
        osmType: 4,
        useSSL: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default OpenStreetMapProvider;
